'use strict';

var _ = require('lodash');
var angular = require('angular');
var JqxGridController = function JqxGridController($scope, $element, JQXGridSettingsFactory, GridSettings) {
  var ID_PREFIX = '#jqxgrid-';
  var SIMPLE_GRID_DEFAULT_SETTINGS = {
    height: '350px',
    editable: false,
    width: '100%',
    altrows: true,
    sortable: true,
    filterable: true,
    enabletooltips: false,
    columnsresize: true,
    showsortcolumnbackground: false,
    showsortmenuitems: false,
    endCellEditRefreshDisabled: true,
    selectionmode: 'none'
  };
  $scope.simpleGrid = true;
  $scope.jqxInitialized = false;
  $scope.jqxGridSettings = {};
  $scope.jqxGridFeatures = {};
  $scope.jqxGridEventHandlers = {};
  $scope.jqxGridSelector = ID_PREFIX + $scope.gridId;
  $scope.getJqxGridElement = function () {
    if (!$scope.jqxGridElement) {
      $scope.jqxGridElement = $element.find($scope.jqxGridSelector);
    }
    return $scope.jqxGridElement;
  };
  $scope.getSettingsFromFeatures = function () {
    return _.transform($scope.jqxGridFeatures, function (result, item) {
      result = _.extend(result, item);
      return result;
    });
  };
  $scope.updateJqxGridSettings = function () {
    var jqxSettings = $scope.buildJqxGridSettings($scope.gridSettings);
    var jqxSource = $scope.buildJqxGridSource($scope.gridSettings);
    $scope.jqxGridSettings = _.extend(jqxSettings, jqxSource);
  };
  $scope.buildJqxGridSettings = function (settingsData) {
    var inputSettings = _.extend({
      gridId: $scope.gridId
    }, settingsData);
    var gridSettings = new GridSettings(inputSettings);
    var jqxGridSettings = JQXGridSettingsFactory.getSimpleJQXGridSettings(gridSettings);
    var featureSettings = $scope.getSettingsFromFeatures();
    var userSettings = _.omit(settingsData, 'columns');
    return _.extend(SIMPLE_GRID_DEFAULT_SETTINGS, userSettings, featureSettings, jqxGridSettings);
  };
  $scope.buildJqxGridSource = function (settingsData) {
    var dataSource = $scope.buildDataAdapter(settingsData);
    return {
      source: new angular.element.jqx.dataAdapter(dataSource)
    };
  };
  $scope.buildDataAdapter = function (settingsData) {
    var dataSource = {
      localdata: $scope.gridData || [],
      datatype: 'array'
    };
    if (settingsData) {
      dataSource = _.extend(dataSource, {
        datafields: $scope.getDataFieldSettings(settingsData),
        beforeprocessing: function beforeprocessing(data) {
          dataSource.totalrecords = data.length;
        }
      });
    }
    return dataSource;
  };
  function mapDataField(column) {
    return {
      name: column.field,
      type: column.fieldType
    };
  }
  function mapColumnOrGroup(column) {
    return column.columns ? _.map(column.columns, mapDataField) : mapDataField(column);
  }
  $scope.getDataFieldSettings = function (settings) {
    return _.chain(settings.columns).map(mapColumnOrGroup).flatten().value();
  };
};
JqxGridController.$inject = ['$scope', '$element', 'JQXGridSettingsFactory', 'GridSettingsFactory'];
module.exports = JqxGridController;